<template>
  <button
    :disabled="disabled"
    :class="'btn--' + color"
    :type="type"
    class="btn">
    {{ label }}
  </button>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      value: ''
    }
  },
  props: {
    label: {
      type: String,
      required: true,
      default: ''
    },
    color: {
      type: String,
      required: true,
      default: ''
    },
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="postcss" scoped>
  .btn {
    width: 100%;
    height: 45px;
    border-radius: 23px;
    border: none;
    box-sizing: border-box;
    font-size: 16px;
    font-weight: 700;
    line-height: 43px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, .16);
    &:disabled {
      pointer-events: none;
      background: #dddddd;
    }

    &--right {
      position: fixed;
      right: 20px;
    }

    &--red {
    background-color: rgb(215, 0, 15);
    color: #fff;
    }

    &--borderRed {
      background: #fff;
      color: rgb(215, 0, 15);
      border: 1px solid rgb(215, 0, 15);
    }

    &--black {
      background: #111;
      color: #fff;
    }

    &--gray {
      background: #bbb;
      color: #fff;
    }

    &--white {
      background: #fff;
      border: 1px solid #ddd;
      color: #333;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/Btn.vue